import { useState } from "react";
import { useNavigate } from "react-router-dom";
import usePage from "../../hooks/usePage";
import "./login.sass";

export default function Login() {
  usePage({ headerShow: false });
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();

  return (
    <div className="login">
      <div className="login-item">
        <div className="login-title">帳號：</div>
        <input
          className="login-value"
          type="text"
          onChange={(e) => {
            setUserId(e.target.value);
          }}
        />
      </div>
      <div className="login-item">
        <div className="login-title">姓名：</div>
        <input
          className="login-value"
          type="text"
          onChange={(e) => {
            setUserName(e.target.value);
          }}
        />
      </div>
      <button
        className="login-action"
        onClick={() => {
          if (!!userId && !!userName) {
            localStorage.setItem("userId", userId);
            localStorage.setItem("userName", userName);
            navigate("/");
          }
        }}
      >
        登入
      </button>
    </div>
  );
}
